import http from 'plugins/axios';

export default {

    ruleList(data) {
        return http.get({
            url: '/wallet/admin/approval/ruleList',
            data
        });
    },  

    approvalswitch(data) {
        return http.get({
            url: '/wallet/admin/approval/switch',
            data
        });
    },              
    paramsDetail(data) {
        return http.get({
            url: '/wallet/admin/approval/paramsDetail',
            data
        });
    },   

    adjustParams(data) {
        return http.post({
            url: '/wallet/admin/approval/adjustParams',
            data,
        });
    },  

    network(data) {
        return http.get({
            url: '/wallet/admin/approval/network',
            data
        });
    },   

    getadjustNetwork(data) {
        return http.post({
            url: '/wallet/admin/approval/adjustNetwork',
            data,
        });
    }, 

    specialCoinList(data) {
        return http.get({
            url: '/wallet/admin/approval/specialCoinList',
            data
        });
    },   

    adjustSpecialCoins(data) {
        return http.post({
            url: '/wallet/admin/approval/adjustSpecialCoins',
            data,
        });
    }, 

    
};
